import type { SVGProps } from 'react';

const SvgCoinColor = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height='1em'
    viewBox='0 0 25 24'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M18.834 12.65v3.7c0 3.12-2.91 5.65-6.5 5.65s-6.5-2.53-6.5-5.65v-3.7c0 3.12 2.91 5.35 6.5 5.35s6.5-2.23 6.5-5.35Z'
      fill='#FFC522'
    />
    <path
      d='M18.834 7.65v5c0 3.12-2.91 5.35-6.5 5.35s-6.5-2.23-6.5-5.35v-5c0 .91.25 1.75.69 2.47 1.07 1.76 3.27 2.88 5.81 2.88 2.54 0 4.74-1.12 5.81-2.88.44-.72.69-1.56.69-2.47Z'
      fill='#FFF0C0'
    />
    <path
      d='M18.834 7.65c0 .91-.25 1.75-.69 2.47-1.07 1.76-3.27 2.88-5.81 2.88-2.54 0-4.74-1.12-5.81-2.88-.44-.72-.69-1.56-.69-2.47 0-3.12 2.91-5.65 6.5-5.65 1.8 0 3.42.63 4.6 1.65 1.17 1.03 1.9 2.44 1.9 4Z'
      fill='#FFC522'
    />
  </svg>
);
export default SvgCoinColor;
